import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from '../../styles/style.module.scss';
import { ReactComponent as UnlockIcon } from '../../../personal-plan-metabolism/styles/unlockIcon.svg';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import getLocale from 'src/localization/get-locale';

export const GuideContainer = () => {
  const { guide } = useRemoteConfig();
  const locale = getLocale();

  return (
    <div className={styles.bodyBalanceContainer}>
      <Title tag='h4'>{guide.title[locale]}</Title>
      <div>
        <Text size='m' medium style={{ color: '#8A8A8A' }}>
          {guide.text[locale]}
        </Text>
        <Text size='m' medium className={styles.bodyBalanceDesc} style={{ color: '#8A8A8A' }}>
          {guide.text[locale]}
        </Text>
        <div className={styles.unlock}>
          <UnlockIcon />
          <Text size='l' semibold style={{ color: '#00CE00' }}>
            {guide.blurText[locale]}
          </Text>
        </div>
      </div>
    </div>
  );
};
